

import React, { useState, useEffect } from 'react';
import { generateLocalQR } from './qrLocal';
import { getTemplateSVG } from './qrTemplateSVG';
import './QRGenerator.css';

function TemplateThumbsGrid({ templates, selectedTemplate, onSelect }) {
  const [thumbSVGs, setThumbSVGs] = useState(new Array(templates.length).fill(null));

  useEffect(() => {
    let mounted = true;
    async function loadThumbs() {
      const svgs = await Promise.all(
        templates.map(t =>
          getTemplateSVG({
            data: 'https://qrcodexpress.com',
            ...t,
            gradient: t.gradient,
            gradientColor1: t.gradientColor1,
            gradientColor2: t.gradientColor2,
            gradientType: t.gradientType || 'linear',
            size: 64,
            // allow thumbs to show a small logo when provided
            logoDataUrl: t.logoDataUrl,
            logoMode: t.logoMode,
          })
        )
      );
      if (mounted) setThumbSVGs(svgs);
    }
    loadThumbs();
    return () => { mounted = false; };
  }, [templates]);
  // Renderização dos thumbs (grid compacto)
  return (
    <div className="template-thumbs-grid" style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'flex-start' }}>
      {templates.map((t, i) => (
        <div
          key={t.name}
          className={
            'template-thumb' +
            (selectedTemplate && t.body === selectedTemplate.body && t.eye === selectedTemplate.eye && t.eyeBall === selectedTemplate.eyeBall && t.logoMode === selectedTemplate.logoMode ? ' selected' : '')
          }
          onClick={() => onSelect(t)}
          style={{ cursor: 'pointer', border: '1px solid #eee', borderRadius: 8, padding: 6, background: '#fff', width: 78, textAlign: 'center', boxSizing: 'border-box' }}
        >
          <div style={{ width: 56, height: 56, margin: '0 auto' }}
            dangerouslySetInnerHTML={{ __html: thumbSVGs[i] || '' }}
          />
          <div style={{ fontSize: 11, marginTop: 6, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{t.name}</div>
        </div>
      ))}
    </div>
  );
}

function QRGenerator(props) {
  // Props
  const { token, saveQrHistory } = props;
  // Estados para conteúdo do QR
  // Cores e design
  const [bodyColor, setBodyColor] = useState('#13294B');
  const [bgColor, setBgColor] = useState('#FFFFFF');
  const [gradient, setGradient] = useState(false);
  const [tab, setTab] = useState('url');
  const [qrText, setQrText] = useState('https://website.com');
  const [emailTo, setEmailTo] = useState('');
  const [emailSubject, setEmailSubject] = useState('');
  const [emailBody, setEmailBody] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [smsNumber, setSmsNumber] = useState('');
  const [smsBody, setSmsBody] = useState('');
  const [wifiSsid, setWifiSsid] = useState('');
  const [wifiPass, setWifiPass] = useState('');
  const [wifiEnc, setWifiEnc] = useState('WPA');
  const [wifiHidden, setWifiHidden] = useState(false);
  const [vcFirst, setVcFirst] = useState('');
  const [vcLast, setVcLast] = useState('');
  const [vcOrg, setVcOrg] = useState('');
  const [vcTitle, setVcTitle] = useState('');
  const [vcPhone, setVcPhone] = useState('');
  const [vcEmail, setVcEmail] = useState('');
  const [vcUrl, setVcUrl] = useState('');
  const [geoLat, setGeoLat] = useState('');
  const [geoLng, setGeoLng] = useState('');
  const [fbUrl, setFbUrl] = useState('');
  const [twText, setTwText] = useState('');
  const [twUrl, setTwUrl] = useState('');
  const [ytUrl, setYtUrl] = useState('');
  const [evTitle, setEvTitle] = useState('');
  const [evLocation, setEvLocation] = useState('');
  const [evStart, setEvStart] = useState('');
  const [evEnd, setEvEnd] = useState('');
  const [evDesc, setEvDesc] = useState('');
  const [btcAddress, setBtcAddress] = useState('');
  const [btcAmount, setBtcAmount] = useState('');
  const [pixKey, setPixKey] = useState('');
  const [pixName, setPixName] = useState('');
  const [pixCity, setPixCity] = useState('');
  const [pixAmount, setPixAmount] = useState('');
  const [pixDescription, setPixDescription] = useState('');
  const [pixTxid, setPixTxid] = useState('');
  const [pixTouched, setPixTouched] = useState(false);
  const [gradientColor1, setGradientColor1] = useState('#1B4965');
  const [gradientColor2, setGradientColor2] = useState('#5FA8D3');
  const [gradientType, setGradientType] = useState('linear');

  // design
  const [body, setBody] = useState('square');
  const [eye, setEye] = useState('frame0');
  const [eyeBall, setEyeBall] = useState('ball0');

  // size and file
  const [size, setSize] = useState(600);
  const [fileType, setFileType] = useState('png');

  // logo
  const [logoFile, setLogoFile] = useState(null);
  const [logoDataUrl, setLogoDataUrl] = useState('');
  const [logoModeClean, setLogoModeClean] = useState(false);

  // design templates
const TEMPLATES = [
  { name: 'Azul Clássico', body: 'square', eye: 'frame0', eyeBall: 'ball0', bodyColor: '#1F3C88', bgColor: '#FFFFFF' },
  { name: 'Esmeralda', body: 'rounded-in', eye: 'frame14', eyeBall: 'ball16', bodyColor: '#2ECC71', bgColor: '#FFFFFF' },
  { name: 'Pôr do Sol', body: 'dot', eye: 'frame10', eyeBall: 'ball11', bodyColor: '#FF6B6B', bgColor: '#FFE66D' },
  { name: 'Mono Escuro', body: 'square', eye: 'frame8', eyeBall: 'ball2', bodyColor: '#111827', bgColor: '#E5E7EB' },
  { name: 'Gradiente Oceano', body: 'circular', eye: 'frame12', eyeBall: 'ball14', gradient: true, gradientColor1: '#0EA5E9', gradientColor2: '#22D3EE', bgColor: '#FFFFFF' },
  // Novos modelos com logo e formatos diferentes
  { name: 'Logo Limpo', body: 'dot', eye: 'frame0', eyeBall: 'ball0', bodyColor: '#0EA5E9', bgColor: '#fff', logoMode: 'clean', logoDataUrl: '/logo192.png' },
  { name: 'Logo Escuro', body: 'classy', eye: 'frame8', eyeBall: 'ball2', bodyColor: '#22223B', bgColor: '#F2E9E4', logoMode: 'default', logoDataUrl: '/logo192.png' },
  { name: 'Logo Arredondado', body: 'rounded-in-smooth', eye: 'frame14', eyeBall: 'ball16', bodyColor: '#43AA8B', bgColor: '#F9F9F9', logoMode: 'clean', logoDataUrl: '/logo192.png' },
  { name: 'Logo Gradiente', body: 'circular', eye: 'frame12', eyeBall: 'ball14', gradient: true, gradientColor1: '#F72585', gradientColor2: '#7209B7', bgColor: '#fff', logoMode: 'default', logoDataUrl: '/logo192.png' },
  { name: 'Laranja Divertido', body: 'classy-rounded', eye: 'frame10', eyeBall: 'ball19', bodyColor: '#FFB703', bgColor: '#FFF3E2', logoMode: 'default', logoDataUrl: '/logo192.png' },
  { name: 'Minimalista', body: 'square', eye: 'frame0', eyeBall: 'ball0', bodyColor: '#222', bgColor: '#fff', logoMode: 'clean', logoDataUrl: '/logo192.png' },
];

  // output
  const [imageDataUrl, setImageDataUrl] = useState('');
  const [loading, setLoading] = useState(false);

  // Função para upload de logo
  const uploadLogo = async (file) => {
    if (!file) return;
    try {
      const reader = new FileReader();
      reader.onload = () => setLogoDataUrl(reader.result);
      reader.readAsDataURL(file);
    } catch (e) {
      console.error(e);
    }
  };

  // Função para montar o conteúdo do QR
  const tlv = (id, value = '') => `${id}${String(value.length).padStart(2, '0')}${value}`;

  const normalizePixText = (value, maxLength) => {
    const cleaned = (value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^A-Za-z0-9 .,\-/]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toUpperCase();
    return cleaned.slice(0, maxLength);
  };

  const calculateCRC16 = (payload) => {
    let crc = 0xFFFF;
    for (let i = 0; i < payload.length; i += 1) {
      crc ^= payload.charCodeAt(i) << 8;
      for (let bit = 0; bit < 8; bit += 1) {
        crc = (crc & 0x8000) ? ((crc << 1) ^ 0x1021) : (crc << 1);
        crc &= 0xFFFF;
      }
    }
    return crc.toString(16).toUpperCase().padStart(4, '0');
  };

  const buildPixPayload = () => {
    const key = (pixKey || '').trim();
    if (!key) return '';

    const merchantName = normalizePixText(pixName || 'RECEBEDOR PIX', 25) || 'RECEBEDOR PIX';
    const merchantCity = normalizePixText(pixCity || 'SAO PAULO', 15) || 'SAO PAULO';
    const txid = (normalizePixText(pixTxid || '***', 25) || '***').replace(/\s/g, '');
    const description = (pixDescription || '').trim().slice(0, 72);
    const amountInput = (pixAmount || '').replace(',', '.').trim();
    const amount = /^\d+(\.\d{1,2})?$/.test(amountInput) ? Number(amountInput).toFixed(2) : '';

    const merchantAccountInfo = tlv(
      '26',
      `${tlv('00', 'BR.GOV.BCB.PIX')}${tlv('01', key)}${description ? tlv('02', description) : ''}`
    );

    let payload = '';
    payload += tlv('00', '01');
    payload += tlv('01', '12');
    payload += merchantAccountInfo;
    payload += tlv('52', '0000');
    payload += tlv('53', '986');
    if (amount) payload += tlv('54', amount);
    payload += tlv('58', 'BR');
    payload += tlv('59', merchantName);
    payload += tlv('60', merchantCity);
    payload += tlv('62', tlv('05', txid));

    const payloadForCRC = `${payload}6304`;
    return `${payloadForCRC}${calculateCRC16(payloadForCRC)}`;
  };

  const buildContent = () => {
    switch (tab) {
      case 'url':
        return qrText;
      case 'text':
        return qrText;
      case 'email': {
        const params = new URLSearchParams();
        if (emailSubject) params.set('subject', emailSubject);
        if (emailBody) params.set('body', emailBody);
        const qs = params.toString();
        return `mailto:${emailTo}${qs ? `?${qs}` : ''}`;
      }
      case 'phone':
        return `tel:${phoneNumber}`;
      case 'sms': {
        const params = new URLSearchParams();
        if (smsBody) params.set('body', smsBody);
        const qs = params.toString();
        return `sms:${smsNumber}${qs ? `?${qs}` : ''}`;
      }
      case 'wifi': {
        const T = wifiEnc === 'nopass' ? 'nopass' : wifiEnc;
        const S = wifiSsid.replace(/[;,:\\"]/g, '\\$&');
        const P = wifiPass.replace(/[;,:\\"]/g, '\\$&');
        const H = wifiHidden ? 'true' : 'false';
        return `WIFI:T:${T};S:${S};${wifiEnc!=='nopass' ? `P:${P};` : ''}H:${H};`;
      }
      case 'vcard': {
        const N = `${vcLast};${vcFirst};;;`;
        const FN = `${vcFirst} ${vcLast}`.trim();
        let v = 'BEGIN:VCARD\nVERSION:3.0\n';
        v += `N:${N}\nFN:${FN}\n`;
        if (vcOrg) v += `ORG:${vcOrg}\n`;
        if (vcTitle) v += `TITLE:${vcTitle}\n`;
        if (vcPhone) v += `TEL;TYPE=CELL:${vcPhone}\n`;
        if (vcEmail) v += `EMAIL:${vcEmail}\n`;
        if (vcUrl) v += `URL:${vcUrl}\n`;
        v += 'END:VCARD';
        return v;
      }
      case 'location': {
        const lat = (geoLat || '').trim();
        const lng = (geoLng || '').trim();
        if (!lat || !lng) return '';
        return `geo:${lat},${lng}`;
      }
      case 'facebook':
        return fbUrl || '';
      case 'twitter': {
        if (twText) {
          const q = new URLSearchParams({ text: twText });
          if (twUrl) q.set('url', twUrl);
          return `https://twitter.com/intent/tweet?${q.toString()}`;
        }
        return twUrl || '';
      }
      case 'youtube':
        return ytUrl || '';
      case 'event': {
        const fmt = (s) => s ? s.replace(/[-:]/g,'').replace(/\.\d{3}Z?$/,'Z') : '';
        const DTSTART = fmt(evStart);
        const DTEND = fmt(evEnd);
        let e = 'BEGIN:VEVENT\n';
        if (evTitle) e += `SUMMARY:${evTitle}\n`;
        if (evLocation) e += `LOCATION:${evLocation}\n`;
        if (DTSTART) e += `DTSTART:${DTSTART}\n`;
        if (DTEND) e += `DTEND:${DTEND}\n`;
        if (evDesc) e += `DESCRIPTION:${evDesc}\n`;
        e += 'END:VEVENT';
        return `BEGIN:VCALENDAR\nVERSION:2.0\n${e}\nEND:VCALENDAR`;
      }
      case 'bitcoin': {
        const params = new URLSearchParams();
        if (btcAmount) params.set('amount', btcAmount);
        const qs = params.toString();
        return `bitcoin:${btcAddress}${qs ? `?${qs}` : ''}`;
      }
      case 'pix':
        return buildPixPayload();
      default:
        return qrText;
    }
  };

  // Função para aplicar template
  const applyTemplate = (template) => {
    setBody(template.body);
    setEye(template.eye);
    setEyeBall(template.eyeBall);
    
    if (template.gradient) {
      setGradient(true);
      setGradientColor1(template.gradientColor1 || '#000000');
      setGradientColor2(template.gradientColor2 || '#555555');
      setGradientType(template.gradientType || 'linear');
    } else {
      setGradient(false);
    }
    
    if (template.bodyColor) setBodyColor(template.bodyColor);
    if (template.bgColor) setBgColor(template.bgColor);
  };

  // Função para gerar o QR
  const generateQR = async () => {
    if (tab === 'pix' && !pixKey.trim()) {
      setPixTouched(true);
      return;
    }

    setLoading(true);
    try {
      const config = {
        body,
        eye,
        eyeBall,
        bodyColor,
        bgColor,
        gradientColor1: gradient ? gradientColor1 : null,
        gradientColor2: gradient ? gradientColor2 : null,
        gradientType,
        gradientOnEyes: gradient,
        logoMode: logoModeClean ? 'clean' : 'default',
      };

      const dataUrl = await generateLocalQR({
        data: buildContent(),
        config,
        size,
        file: fileType,

        logoDataUrl,
      });
      setImageDataUrl(dataUrl);

      // Salvar no histórico se logado
      console.log('[QRGenerator] Checando salvamento:', { 
        token: token ? 'presente' : 'ausente', 
        saveQrHistory: saveQrHistory ? 'função presente' : 'função ausente' 
      });
      if (token && saveQrHistory) {
        console.log('[QRGenerator] Salvando QR no histórico...');
        saveQrHistory(buildContent(), config, size, fileType);
      } else {
        console.log('[QRGenerator] Não salvando - token ou função ausente');
      }
    } catch (error) {
      console.error(error);
      alert('Falha ao gerar o QR Code');
    } finally {
      setLoading(false);
    }
  };

  // Função para download
  const handleDownloadQR = () => {
    if (!imageDataUrl) return;
    const link = document.createElement('a');
    link.href = imageDataUrl;
    link.download = `qrcode.${fileType}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="generator-container">
      <div className="how-visual-header">
        <h2 className="how-visual-title">Gerar seu próprio QR Code nunca foi tão fácil!</h2>
        <p className="how-visual-subtitle">
          Crie QR Codes profissionais em 3 passos simples. Veja como é intuitivo e rápido:
        </p>
      </div>
      
      <div className="layout">
      <div className="left">
        <div className="accordion">
          <details open>
            <summary>Tipo de Conteúdo</summary>
            <div className="section">
              <div className="content-type-grid">
                <button 
                  type="button"
                  className={`content-type-btn ${tab === 'url' ? 'active' : ''}`}
                  onClick={() => setTab('url')}
                >
                  <span className="content-icon">🔗</span>
                  <span className="content-label">URL</span>
                </button>
                <button 
                  type="button"
                  className={`content-type-btn ${tab === 'text' ? 'active' : ''}`}
                  onClick={() => setTab('text')}
                >
                  <span className="content-icon">📝</span>
                  <span className="content-label">Texto</span>
                </button>
                <button 
                  type="button"
                  className={`content-type-btn ${tab === 'email' ? 'active' : ''}`}
                  onClick={() => setTab('email')}
                >
                  <span className="content-icon">✉️</span>
                  <span className="content-label">Email</span>
                </button>
                <button 
                  type="button"
                  className={`content-type-btn ${tab === 'phone' ? 'active' : ''}`}
                  onClick={() => setTab('phone')}
                >
                  <span className="content-icon">📞</span>
                  <span className="content-label">Telefone</span>
                </button>
                <button 
                  type="button"
                  className={`content-type-btn ${tab === 'sms' ? 'active' : ''}`}
                  onClick={() => setTab('sms')}
                >
                  <span className="content-icon">💬</span>
                  <span className="content-label">SMS</span>
                </button>
                <button 
                  type="button"
                  className={`content-type-btn ${tab === 'wifi' ? 'active' : ''}`}
                  onClick={() => setTab('wifi')}
                >
                  <span className="content-icon">📶</span>
                  <span className="content-label">Wi-Fi</span>
                </button>
                <button 
                  type="button"
                  className={`content-type-btn ${tab === 'vcard' ? 'active' : ''}`}
                  onClick={() => setTab('vcard')}
                >
                  <span className="content-icon">👤</span>
                  <span className="content-label">Contato</span>
                </button>
                <button 
                  type="button"
                  className={`content-type-btn ${tab === 'location' ? 'active' : ''}`}
                  onClick={() => setTab('location')}
                >
                  <span className="content-icon">📍</span>
                  <span className="content-label">Localização</span>
                </button>
                <button 
                  type="button"
                  className={`content-type-btn ${tab === 'facebook' ? 'active' : ''}`}
                  onClick={() => setTab('facebook')}
                >
                  <span className="content-icon">📘</span>
                  <span className="content-label">Facebook</span>
                </button>
                <button 
                  type="button"
                  className={`content-type-btn ${tab === 'twitter' ? 'active' : ''}`}
                  onClick={() => setTab('twitter')}
                >
                  <span className="content-icon">🐦</span>
                  <span className="content-label">Twitter</span>
                </button>
                <button 
                  type="button"
                  className={`content-type-btn ${tab === 'youtube' ? 'active' : ''}`}
                  onClick={() => setTab('youtube')}
                >
                  <span className="content-icon">▶️</span>
                  <span className="content-label">YouTube</span>
                </button>
                <button 
                  type="button"
                  className={`content-type-btn ${tab === 'event' ? 'active' : ''}`}
                  onClick={() => setTab('event')}
                >
                  <span className="content-icon">📅</span>
                  <span className="content-label">Evento</span>
                </button>
                <button 
                  type="button"
                  className={`content-type-btn ${tab === 'bitcoin' ? 'active' : ''}`}
                  onClick={() => setTab('bitcoin')}
                >
                  <span className="content-icon">₿</span>
                  <span className="content-label">Bitcoin</span>
                </button>
                <button 
                  type="button"
                  className={`content-type-btn ${tab === 'pix' ? 'active' : ''}`}
                  onClick={() => setTab('pix')}
                >
                  <span className="content-icon">💠</span>
                  <span className="content-label">PIX</span>
                </button>
              </div>
              
              <div className="content-fields">
              </div>
              
              <div className="content-fields">
              {tab==='url' && (
                <input placeholder='https://...' value={qrText} onChange={e=>setQrText(e.target.value)} />
              )}
              {tab==='text' && (
                <textarea placeholder='Texto livre' value={qrText} onChange={e=>setQrText(e.target.value)} />
              )}
              {tab==='email' && (
                <div className="grid2">
                  <input placeholder='Para (email)' value={emailTo} onChange={e=>setEmailTo(e.target.value)} />
                  <input placeholder='Assunto' value={emailSubject} onChange={e=>setEmailSubject(e.target.value)} />
                  <textarea placeholder='Mensagem' value={emailBody} onChange={e=>setEmailBody(e.target.value)} />
                </div>
              )}
              {tab==='phone' && (
                <input placeholder='Número de telefone' value={phoneNumber} onChange={e=>setPhoneNumber(e.target.value)} />
              )}
              {tab==='sms' && (
                <div className="grid2">
                  <input placeholder='Número' value={smsNumber} onChange={e=>setSmsNumber(e.target.value)} />
                  <textarea placeholder='Mensagem' value={smsBody} onChange={e=>setSmsBody(e.target.value)} />
                </div>
              )}
              {tab==='wifi' && (
                <div className="grid2">
                  <input placeholder='SSID' value={wifiSsid} onChange={e=>setWifiSsid(e.target.value)} />
                  <input placeholder='Senha' value={wifiPass} onChange={e=>setWifiPass(e.target.value)} />
                  <select value={wifiEnc} onChange={e=>setWifiEnc(e.target.value)}>
                    <option value="WPA">WPA/WPA2</option>
                    <option value="WEP">WEP</option>
                    <option value="nopass">Sem senha</option>
                  </select>
                  <label><input type="checkbox" checked={wifiHidden} onChange={e=>setWifiHidden(e.target.checked)} /> Rede oculta</label>
                </div>
              )}
              {tab==='vcard' && (
                <div className="grid2">
                  <input placeholder='Nome' value={vcFirst} onChange={e=>setVcFirst(e.target.value)} />
                  <input placeholder='Sobrenome' value={vcLast} onChange={e=>setVcLast(e.target.value)} />
                  <input placeholder='Empresa' value={vcOrg} onChange={e=>setVcOrg(e.target.value)} />
                  <input placeholder='Cargo' value={vcTitle} onChange={e=>setVcTitle(e.target.value)} />
                  <input placeholder='Telefone' value={vcPhone} onChange={e=>setVcPhone(e.target.value)} />
                  <input placeholder='Email' value={vcEmail} onChange={e=>setVcEmail(e.target.value)} />
                  <input placeholder='Site' value={vcUrl} onChange={e=>setVcUrl(e.target.value)} />
                </div>
              )}
              {tab==='location' && (
                <div className="grid2">
                  <input placeholder='Latitude' value={geoLat} onChange={e=>setGeoLat(e.target.value)} />
                  <input placeholder='Longitude' value={geoLng} onChange={e=>setGeoLng(e.target.value)} />
                </div>
              )}
              {tab==='facebook' && (
                <input placeholder='Link para página/perfil' value={fbUrl} onChange={e=>setFbUrl(e.target.value)} />
              )}
              {tab==='twitter' && (
                <div className="grid2">
                  <textarea placeholder='Texto do tweet' value={twText} onChange={e=>setTwText(e.target.value)} />
                  <input placeholder='URL opcional' value={twUrl} onChange={e=>setTwUrl(e.target.value)} />
                </div>
              )}
              {tab==='youtube' && (
                <input placeholder='URL do vídeo ou canal' value={ytUrl} onChange={e=>setYtUrl(e.target.value)} />
              )}
              {tab==='event' && (
                <div className="grid2">
                  <input placeholder='Título' value={evTitle} onChange={e=>setEvTitle(e.target.value)} />
                  <input placeholder='Local' value={evLocation} onChange={e=>setEvLocation(e.target.value)} />
                  <input type='datetime-local' placeholder='Início' value={evStart} onChange={e=>setEvStart(e.target.value)} />
                  <input type='datetime-local' placeholder='Fim' value={evEnd} onChange={e=>setEvEnd(e.target.value)} />
                  <textarea placeholder='Descrição' value={evDesc} onChange={e=>setEvDesc(e.target.value)} />
                </div>
              )}
              {tab==='bitcoin' && (
                <div className="grid2">
                  <input placeholder='Endereço BTC' value={btcAddress} onChange={e=>setBtcAddress(e.target.value)} />
                  <input placeholder='Valor (BTC)' value={btcAmount} onChange={e=>setBtcAmount(e.target.value)} />
                </div>
              )}
              {tab==='pix' && (
                <div className="grid2">
                  <input
                    placeholder='Chave PIX (CPF, email, telefone ou aleatória)'
                    value={pixKey}
                    onChange={e=>setPixKey(e.target.value)}
                    onBlur={() => setPixTouched(true)}
                    aria-invalid={pixTouched && !pixKey.trim() ? 'true' : 'false'}
                  />
                  <input placeholder='Nome do recebedor' value={pixName} onChange={e=>setPixName(e.target.value)} />
                  <input placeholder='Cidade do recebedor' value={pixCity} onChange={e=>setPixCity(e.target.value)} />
                  <input placeholder='Valor (opcional)' value={pixAmount} onChange={e=>setPixAmount(e.target.value)} />
                  <input placeholder='Identificador TXID (opcional)' value={pixTxid} onChange={e=>setPixTxid(e.target.value)} />
                  <textarea placeholder='Descrição (opcional)' value={pixDescription} onChange={e=>setPixDescription(e.target.value)} />
                  {pixTouched && !pixKey.trim() && (
                    <small style={{ gridColumn: '1 / -1', color: '#9a7b49', marginTop: -4 }}>
                      A chave PIX é obrigatória para gerar o QR Code.
                    </small>
                  )}
                </div>
              )}
              </div>
            </div>
          </details>

          <details>
            <summary>Definir Cores</summary>
            <div className="section color-section">
              <div className="color-mode-selector">
                <label className="color-mode-label">Cor do Primeiro Plano</label>
                <div className="color-mode-options">
                  <label className="radio-option">
                    <input 
                      type="radio" 
                      name="colorMode" 
                      checked={!gradient} 
                      onChange={() => setGradient(false)}
                    />
                    <span>Cor única</span>
                  </label>
                  <label className="radio-option">
                    <input 
                      type="radio" 
                      name="colorMode" 
                      checked={gradient} 
                      onChange={() => setGradient(true)}
                    />
                    <span>Usar degradê</span>
                  </label>
                </div>
                
                <div className="color-pickers-row">
                  <div className="color-picker-item">
                    <input 
                      type="color" 
                      value={bodyColor} 
                      onChange={e => setBodyColor(e.target.value)}
                      className="color-input-large"
                    />
                    <input 
                      type="text" 
                      value={bodyColor} 
                      onChange={e => setBodyColor(e.target.value)}
                      className="color-hex-input"
                      placeholder="#000000"
                    />
                  </div>
                  
                  {gradient && (
                    <>
                      <div className="color-picker-item">
                        <input 
                          type="color" 
                          value={gradientColor2} 
                          onChange={e => setGradientColor2(e.target.value)}
                          className="color-input-large"
                        />
                        <input 
                          type="text" 
                          value={gradientColor2} 
                          onChange={e => setGradientColor2(e.target.value)}
                          className="color-hex-input"
                          placeholder="#0277bd"
                        />
                      </div>
                      
                      <div className="gradient-type-selector">
                        <button 
                          type="button"
                          className={`gradient-btn ${gradientType === 'linear' ? 'active' : ''}`}
                          onClick={() => setGradientType('linear')}
                        >
                          ⬌ Gradiente Linear
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </div>

              <div className="color-bg-selector">
                <label className="color-mode-label">Cor de fundo</label>
                <div className="color-picker-item">
                  <input 
                    type="color" 
                    value={bgColor} 
                    onChange={e => setBgColor(e.target.value)}
                    className="color-input-large"
                  />
                  <input 
                    type="text" 
                    value={bgColor} 
                    onChange={e => setBgColor(e.target.value)}
                    className="color-hex-input"
                    placeholder="#FFFFFF"
                  />
                </div>
              </div>
            </div>
          </details>

          <details>
            <summary>Adicionar Logo</summary>
            <div className="section logo-section">
              <div className="logo-upload-area">
                <label className="logo-upload-button">
                  <input 
                    type="file" 
                    accept="image/*" 
                    onChange={e => { 
                      setLogoFile(e.target.files[0]); 
                      uploadLogo(e.target.files[0]); 
                    }} 
                    style={{display: 'none'}}
                  />
                  <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12"/>
                  </svg>
                  <span>{logoFile ? logoFile.name : 'Escolher arquivo'}</span>
                </label>
                {logoFile && (
                  <button 
                    type="button" 
                    className="remove-logo-btn"
                    onClick={() => {setLogoFile(null); setLogoDataUrl(null);}}
                    title="Remover logo"
                  >
                    ✕
                  </button>
                )}
              </div>
              
              {logoDataUrl && (
                <div className="logo-preview">
                  <img src={logoDataUrl} alt="Logo preview" />
                </div>
              )}
              
              <div className="logo-options">
                <label className="checkbox-option">
                  <input 
                    type="checkbox" 
                    checked={logoModeClean} 
                    onChange={e => setLogoModeClean(e.target.checked)} 
                  />
                  <span>Logo com fundo limpo</span>
                </label>
              </div>
            </div>
          </details>

          <details>
            <summary>Personalizar Design</summary>
            <div className="section design-section">
              <div className="shape-selector">
                <label className="shape-label">Forma dos pontos</label>
                <div className="shape-grid">
                  <button 
                    type="button" 
                    className={`shape-btn ${body === 'square' ? 'active' : ''}`}
                    onClick={() => setBody('square')}
                    title="Quadrado"
                  >
                    <svg viewBox="0 0 40 40" width="32" height="32">
                      <rect x="4" y="4" width="32" height="32" fill="currentColor"/>
                    </svg>
                    <span>Quadrado</span>
                  </button>
                  
                  <button 
                    type="button" 
                    className={`shape-btn ${body === 'rounded-in' ? 'active' : ''}`}
                    onClick={() => setBody('rounded-in')}
                    title="Recortado"
                  >
                    <svg viewBox="0 0 40 40" width="32" height="32">
                      <rect x="4" y="4" width="32" height="32" rx="8" fill="currentColor"/>
                    </svg>
                    <span>Recortado</span>
                  </button>
                  
                  <button 
                    type="button" 
                    className={`shape-btn ${body === 'dot' ? 'active' : ''}`}
                    onClick={() => setBody('dot')}
                    title="Pontos"
                  >
                    <svg viewBox="0 0 40 40" width="32" height="32">
                      <circle cx="20" cy="20" r="16" fill="currentColor"/>
                    </svg>
                    <span>Pontos</span>
                  </button>
                  
                  <button 
                    type="button" 
                    className={`shape-btn ${body === 'classy' ? 'active' : ''}`}
                    onClick={() => setBody('classy')}
                    title="Clássico"
                  >
                    <svg viewBox="0 0 40 40" width="32" height="32">
                      <rect x="4" y="4" width="32" height="32" rx="4" fill="currentColor"/>
                    </svg>
                    <span>Clássico</span>
                  </button>
                  
                  <button 
                    type="button" 
                    className={`shape-btn ${body === 'circular' ? 'active' : ''}`}
                    onClick={() => setBody('circular')}
                    title="Circular"
                  >
                    <svg viewBox="0 0 40 40" width="32" height="32">
                      <circle cx="20" cy="20" r="14" fill="currentColor"/>
                    </svg>
                    <span>Circular</span>
                  </button>
                </div>
              </div>

              <div className="shape-selector">
                <label className="shape-label">Moldura externa (olhos)</label>
                <div className="shape-grid">
                  <button 
                    type="button" 
                    className={`shape-btn ${eye === 'frame0' ? 'active' : ''}`}
                    onClick={() => setEye('frame0')}
                    title="Quadrada"
                  >
                    <svg viewBox="0 0 40 40" width="32" height="32">
                      <rect x="4" y="4" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="3"/>
                    </svg>
                    <span>Quadrada</span>
                  </button>
                  
                  <button 
                    type="button" 
                    className={`shape-btn ${eye === 'frame2' ? 'active' : ''}`}
                    onClick={() => setEye('frame2')}
                    title="Extra Arred."
                  >
                    <svg viewBox="0 0 40 40" width="32" height="32">
                      <rect x="4" y="4" width="32" height="32" rx="12" fill="none" stroke="currentColor" strokeWidth="3"/>
                    </svg>
                    <span>Extra Arred.</span>
                  </button>
                  
                  <button 
                    type="button" 
                    className={`shape-btn ${eye === 'frame14' ? 'active' : ''}`}
                    onClick={() => setEye('frame14')}
                    title="Círculo"
                  >
                    <svg viewBox="0 0 40 40" width="32" height="32">
                      <circle cx="20" cy="20" r="16" fill="none" stroke="currentColor" strokeWidth="3"/>
                    </svg>
                    <span>Círculo</span>
                  </button>
                  
                  <button 
                    type="button" 
                    className={`shape-btn ${eye === 'frame8' ? 'active' : ''}`}
                    onClick={() => setEye('frame8')}
                    title="Chanfrada"
                  >
                    <svg viewBox="0 0 40 40" width="32" height="32">
                      <path d="M4 12L12 4h16l8 8v16l-8 8H12l-8-8V12z" fill="none" stroke="currentColor" strokeWidth="3"/>
                    </svg>
                    <span>Chanfrada</span>
                  </button>
                </div>
              </div>

              <div className="shape-selector">
                <label className="shape-label">Pupila interna (olhos)</label>
                <div className="shape-grid">
                  <button 
                    type="button" 
                    className={`shape-btn ${eyeBall === 'ball0' ? 'active' : ''}`}
                    onClick={() => setEyeBall('ball0')}
                    title="Quadrada"
                  >
                    <svg viewBox="0 0 40 40" width="32" height="32">
                      <rect x="12" y="12" width="16" height="16" fill="currentColor"/>
                    </svg>
                    <span>Quadrada</span>
                  </button>
                  
                  <button 
                    type="button" 
                    className={`shape-btn ${eyeBall === 'ball14' ? 'active' : ''}`}
                    onClick={() => setEyeBall('ball14')}
                    title="Círculo"
                  >
                    <svg viewBox="0 0 40 40" width="32" height="32">
                      <circle cx="20" cy="20" r="8" fill="currentColor"/>
                    </svg>
                    <span>Círculo</span>
                  </button>
                  
                  <button 
                    type="button" 
                    className={`shape-btn ${eyeBall === 'ball2' ? 'active' : ''}`}
                    onClick={() => setEyeBall('ball2')}
                    title="Arredondada"
                  >
                    <svg viewBox="0 0 40 40" width="32" height="32">
                      <rect x="12" y="12" width="16" height="16" rx="4" fill="currentColor"/>
                    </svg>
                    <span>Arredondada</span>
                  </button>
                  
                  <button 
                    type="button" 
                    className={`shape-btn ${eyeBall === 'ball6' ? 'active' : ''}`}
                    onClick={() => setEyeBall('ball6')}
                    title="Diamante"
                  >
                    <svg viewBox="0 0 40 40" width="32" height="32">
                      <path d="M20 12l8 8-8 8-8-8z" fill="currentColor"/>
                    </svg>
                    <span>Diamante</span>
                  </button>
                </div>
              </div>
            </div>
          </details>

          <details open>
            <summary>Personalizar Tamanho</summary>
            <div className="section">
              <input type="range" min="200" max="1000" step="50" value={size} onChange={e => setSize(Number(e.target.value))} />
              <div>{size} px</div>
              <div className="row">
                <label>Arquivo</label>
                <select value={fileType} onChange={e=>setFileType(e.target.value)}>
                  <option value="png">PNG</option>
                  <option value="svg">SVG</option>
                  <option value="pdf">PDF</option>
                </select>
              </div>
            </div>
          </details>

          <div className="templates-section">
            <h3 className="templates-title">🎨 Templates Prontos</h3>
            <p className="templates-subtitle">Escolha um modelo ou personalize do zero</p>
            <TemplateThumbsGrid templates={TEMPLATES} selectedTemplate={{ body, eye, eyeBall }} onSelect={applyTemplate} />
          </div>

          <div className="actions">
            <button onClick={generateQR} disabled={loading || (tab === 'pix' && !pixKey.trim())}>{loading ? 'Gerando...' : 'Criar QR Code'}</button>
            {imageDataUrl && (
              <button className="secondary" onClick={handleDownloadQR}>Baixar {fileType.toUpperCase()}</button>
            )}
          </div>

        </div>
      </div>
      
      <div className="right">
        {imageDataUrl ? (
          <img src={imageDataUrl} alt="QR Code preview" className="qr-preview-image" />
        ) : (
          <div className="qr-placeholder">
            <div className="qr-placeholder-icon">📱</div>
            <p className="qr-placeholder-text">Seu QR Code aparecerá aqui</p>
            <p className="qr-placeholder-hint">Configure as opções e clique em "Criar QR Code"</p>
          </div>
        )}
      </div>
    </div>
    </div>
  );
}

export default QRGenerator;
